<template>
  <div :class="$style['pass-issue-btn']">
    <div class="d-flex column align-center">
      <div :class="[$style['display'], !this.value ? $style['unissued'] : null]">{{ issuedState }}</div>
      <v-btn small color="primary" class="mx-4" @click="onClick">
        <v-icon left>mdi-account-lock</v-icon>パスワード再発行
      </v-btn>
    </div>
    <div class="mt-2 d-flex">
      <span :class="$style['remarks']">Emailとパスワードは公開されません。</span>
    </div>
  </div>
</template>

<script>
import utility from "@/utility";
import axios from "@/axios";
import store from "@/store";

export default {
  props: {
    value: {
      default: ""
    },
    pk: {
      type: String,
      required: true
    }
  },
  computed: {
    issuedState() {
      return this.value ? "発行しました" : "";
    }
  },
  methods: {
    displayOption(value) {
      return this.option(value) || {};
    },
    onClick() {
      utility
        .$confirm(
          "新規パスワードを登録Email宛に送付します。よろしいですか？",
          "確認",
          {
            confirmButtonText: "送付する",
            cancelButtonText: "キャンセル",
            type: "warning"
          }
        )
        .then(() => {
          axios
            .post(`/users/${this.pk}/passwordissue`) // put
            .then(() => {
              utility.$message({
                type: "success",
                message: "新規パスワードを登録Email宛に送付しました。",
                showClose: true,
                customClass: "el-message-content-position",
                onClose: () => {
                  store.dispatch(`users/entity/show`, { pk: this.pk });
                }
              });
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style module lang="scss">
.pass-issue-btn {
  display: flex;
  flex-direction: column;
}
.display {
  font-size: 13px;
  &.unissued {
    color: red;
  }
}
.remarks {
  font-size: 12px;
  &:before {
    content: "※";
    margin-right: 4px;
  }
}
</style>
